import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../config/api";
import { endPoints } from "../../config";
import { toast } from "react-toastify";

const getRecommendationListData = createAsyncThunk("RECOMMENDATION_LIST", async (values, { rejectWithValue }) => {
    try {
        const data = await api.post(endPoints.RECOMMENDATION.LIST, values);
        return data
    } catch (error) {
        toast.error(error?.ResponseMsg);
        return rejectWithValue(error)
    }
})

const addNewRecommendation = createAsyncThunk("ADD_NEW_RECOMMENDATION", async (values, { rejectWithValue }) => {
    try {
        const data = await api.post(endPoints.RECOMMENDATION.ADD, values);
        toast.success(data?.ResponseMsg);
        return data
    } catch (error) {
        // toast.error(error?.ResponseMsg);
        return rejectWithValue(error)
    }
})

const updateRecommendation = createAsyncThunk("UPDATE_RECOMMENDATION", async (values, { rejectWithValue }) => {
    try {
        const data = await api.post(endPoints.RECOMMENDATION.UPDATE, values);
        toast.success(data?.ResponseMsg);
        return data
    } catch (error) {
        toast.error(error?.ResponseMsg);
        return rejectWithValue(error)
    }
})

const deleteRecommendation = createAsyncThunk("DELETE_RECOMMENDATION", async (values, { rejectWithValue }) => {
    try {
        const data = await api.post(endPoints.RECOMMENDATION.DELETE, values);
        toast.success(data?.ResponseMsg);
        return data
    } catch (error) {
        toast.error(error?.ResponseMsg);
        return rejectWithValue(error)
    }
})


export { getRecommendationListData, addNewRecommendation, updateRecommendation, deleteRecommendation }